import React from "react";
// import './main.css';
import './main.scss';
import { FaMapMarkerAlt, FaClipboardCheck, FaArrowsAltH  } from "react-icons/fa";
import { MdOutlineLabel } from "react-icons/md";

import img1 from '../../Assets/img1.png';
import img2 from '../../Assets/img2.png';
import img3 from '../../Assets/img3.png';
import img4 from '../../Assets/img4.png';
import img5 from '../../Assets/img5.png';
import img6 from '../../Assets/img6.png';
import img7 from '../../Assets/img7.png';
import img8 from '../../Assets/img8.png';
import img9 from '../../Assets/img9.jpeg';
import img10 from '../../Assets/img10.jpeg';
import img11 from '../../Assets/img11.jpeg';
import img12 from '../../Assets/img12.png';
import img13 from '../../Assets/img13.png';
import img14 from '../../Assets/img14.jpg';
import img15 from '../../Assets/img15.png';
import img16 from '../../Assets/img16.png';
import img17 from '../../Assets/img17.jpg';
import img18 from '../../Assets/img18.png';

import alan from '../../Assets/alan.png'
import mario from '../../Assets/mario.png'
import juan from '../../Assets/juan.png'

import testimonio1 from '../../Assets/testimonios/489608023_1241833687949474_1059327410918535042_n.jpg'
import testimonio2 from '../../Assets/testimonios/489813361_1242589111207265_5518094878063560436_n.jpg'
import testimonio3 from '../../Assets/testimonios/489992504_1243464661119710_2879704259911930608_n.jpg'
import testimonio4 from '../../Assets/testimonios/490314849_1245386614260848_4513730445142664713_n.jpg'
import testimonio5 from '../../Assets/testimonios/491935651_1247952594004250_5993525666738407189_n.jpg'
import testimonio6 from '../../Assets/testimonios/492192018_1253689740097202_7993189256119049832_n.jpg'

import anuncio from '../../Assets/Banner1.png'

import Carousel from "../Widgets/Caroussel";
import Testimonials from "../Widgets/carousselSlick"

const Main = () => {
    const Data = [
        {
            id: 1,
            imgSrc: img1,
            terrenoTitle: "Terreno en venta en el puerto de Chelem, comercial",
            location: "Terreno en Chelem, Progreso",
            price: "550,000",
            area: "288",
            label: "terrenos ejidales",
            description: "Terreno en venta en el puerto de Chelem, comercial"
        },
        {
            id: 2,
            imgSrc: img2,
            terrenoTitle: "Terreno en venta en Mérida Yucatán, cholul ideal para desarrollar.",
            location: "Terreno en Cholul, Mérida",
            price: "25,000,000",
            area: "14539",
            label: "JUAN, Inversiones",
            description: "Terreno en venta en Mérida Yucatán, cholul ideal para desarrollar."
        },
        {
            id: 3,
            imgSrc: img3,
            terrenoTitle: "Terreno comercial en venta en Hunucmá Yucatán frente a carretera.",
            location: "Terreno en Hunucmá, Hunucmá",
            price: "1,600,000",
            area: "4327",
            label: "Terreno para construir",
            description: "Terreno comercial en venta en Hunucmá Yucatán frente a carretera."
        },
        {
            id: 4,
            imgSrc: img4,
            terrenoTitle: "Parcela en venta con excelente ubicación a 12 km del Cuyo",
            location: "Terreno en Nuevo Mundo, Tizimín",
            price: "1,700,000",
            area: "440000",
            label: "terrenos ejidales",
            description: "Parcela en venta con excelente ubicación a 12 km del Cuyo"
        },
        {
            id: 5,
            imgSrc: img5,
            terrenoTitle: "Terrenos premium al norte de Mérida Yucatán, listos para construir",
            location: "Terreno en Xcanatún, Mérida",
            price: "1,988,000",
            area: "340",
            label: "Terreno para construir",
            description: "Terrenos premium al norte de Mérida Yucatán, listos para construir"
        },
        {
            id: 6,
            imgSrc: img6,
            terrenoTitle: "Lotes disponibles en la zona de Celestún Yucatán",
            location: "Terreno en Calkini Centro, Calkiní",
            price: "4,500,000",
            area: "1800",
            label: "terrenos para invertir",
            description: "Lotes disponibles en la zona de Celestún Yucatán"
        },
        {
            id: 7,
            imgSrc: img7,
            terrenoTitle: "Terreno en venta en Mococha, Yucatán",
            location: "Terreno en Mococha, Mocochá",
            price: "54,000,000",
            area: "180000",
            label: "Terreno para construir, terrenos para invertir",
            description: "Terreno en venta en Mococha, Yucatán"
        },
        {
            id: 8,
            imgSrc: img8,
            terrenoTitle: "Terreno en venta en Chochoh Yucatán para construir",
            location: "Terreno en Cuca, Tixpéhual",
            price: "13,200,000",
            area: "66000",
            label: "Terreno para construir, terrenos para invertir",
            description: "Terreno en venta en Chochoh Yucatán para construir"
        },
        {
            id: 9,
            imgSrc: img9,
            terrenoTitle: "Una hectárea ideal para construir una quinta",
            location: "Terreno en Plan de Ayala Sur, Mérida",
            price: "2,500,000",
            area: "10000",
            label: "Terreno para construir",
            description: "Una hectárea ideal para construir una quinta"
        },
        {
            id: 10,
            imgSrc: img10,
            terrenoTitle: "Vive dentro de la ciudad de Mérida, cerca de Ixmatkuil",
            location: "Terreno en Plan de Ayala Sur, Mérida",
            price: "450,000",
            area: "513.5",
            label: "Terreno para construir",
            description: "Vive dentro de la ciudad de Mérida, cerca de Ixmatkuil"
        },
        {
            id: 11,
            imgSrc: img11,
            terrenoTitle: "Construye tu casa de playa en este terreno.",
            location: "Terreno en Chuburna Puerto, Progreso",
            price: "2,500,000",
            area: "2618",
            label: "terrenos ejidales, Terreno para construir",
            description: "Construye tu casa de playa en este terreno."
        },
        {
            id: 12,
            imgSrc: img12,
            terrenoTitle: "Terreno en venta en Umán Yucatán",
            location: "Terreno en Poxila, Umán",
            price: "300,000,000",
            area: "600000",
            label: "Terreno para construir",
            description: "Terreno en venta en Umán Yucatán"
        },
        {
            id: 13,
            imgSrc: img13,
            terrenoTitle: "Parcela en venta en Ticopó, Yucatán",
            location: "Terreno en Ticopó, Acanceh",
            price: "1,380,000",
            area: "35000",
            label: "terrenos ejidales",
            description: "Parcela en venta en Ticopó, Yucatán"
        },
        {
            id: 14,
            imgSrc: img14,
            terrenoTitle: "Venta terreno Cholul a 2 km de Paseo Norte",
            location: "Terreno en Alamo, Cholul, Mérida",
            price: "4,653,000",
            area: "1980",
            label: "Terreno para construir",
            description: "Venta terreno Cholul a 2 km de Paseo Norte"
        },
        {
            id: 15,
            imgSrc: img15,
            terrenoTitle: "Terreno en venta en esquina en San Antonio Hool",
            location: "Terreno en Dzityá, Mérida",
            price: "2,700,000",
            area: "1645",
            label: "",
            description: "Terreno en venta en esquina en San Antonio Hool"
        },
        {
            id: 16,
            imgSrc: img16,
            terrenoTitle: "Terreno en venta en esquina en San Antonio Hool, Yucatán",
            location: "Terreno en Dzityá, Mérida",
            price: "2,900,000",
            area: "1645",
            label: "",
            description: "Terreno en venta en esquina en San Antonio Hool, Yucatán"
        },
        {
            id: 17,
            imgSrc: img17,
            terrenoTitle: "Terreno en venta en esquina, San Antonio Hool pegado a la hacienda",
            location: "Terreno en San Antonio Hool, Mérida",
            price: "3,000,000",
            area: "1645",
            label: "Terreno para construir, Inversiones",
            description: "Terreno en venta en esquina, San Antonio Hool pegado a la hacienda"
        },
        {
            id: 18,
            imgSrc: img18,
            terrenoTitle: "Terreno en venta Mérida, Yucatán, Leandro Valle",
            location: "Terreno en Leandro Valle, Mérida",
            price: "1,880,000",
            area: "750",
            label: "terrenos para invertir",
            description: "Terreno en venta Mérida, Yucatán, Leandro Valle"
        }
    ];
    
    const items = [
        {
          image: alan,
          subtitle: 'Alan Alcolea',
          title: 'Desarrollador de software'
        },
        {
          image: mario,
          subtitle: 'Mario Arjona',
          title: 'Funda'
        },
        {
            image: juan,
            subtitle: 'Juan Rivas',
            title: 'Jefe'
        },
    ];

    const testimonialData = [
       {
         name: "Freddy Montero Dajdaj ",
         role: "Cliente",
         testimony: "Recomendado ampliamente, me encontró el terreno acorde a lo que necesitaba. Juan es una persona honesta y confiable",
         avatar: testimonio1
       },
       {
         name: "José Luis Mñz",
         role: "Cliente",
         testimony: "recomiendo ampliamente a Juan Rivas, excelente atención.",
         avatar: testimonio2
       },
       {
         name: "Priscilla Lara",
         role: "Cliente",
         testimony: "Quiero expresar mi agradecimiento y satisfacción por el excelente servicio que recibí de Juan. ¡Ha sido un placer trabajar con alguien tan apasionado por su trabajo! Gracias.",         
         avatar: testimonio3
       },
       {
         name: "Carlos Omar Molina Cohúo",
         role: "Cliente",
         testimony: "Recomendado el servicio de asesoría que otorga Juan. El proceso de para la venta de mi propiedad está siendo demasiado eficiente y rápido.. Muy claro en todos los detalles.",
         avatar: testimonio4
       },
       {
         name: "Carlos Omar Molina Cohúo",
         role: "Cliente",
         testimony: "Comprar con Juan Rivas fue un proceso sencillo y fácil, es muy profesional y siempre ve por el cliente, te da la confianza, lo recomiendo.",
         avatar: testimonio5
       },
       {
         name: "Carlos Omar Molina Cohúo",
         role: "Cliente",
         testimony: "Juanito Rivas es experto en ventas de tierras a muy buen precio, su trato es inmejorable y muy educado, te encuentra exactamente lo que buscas y explica cada detalle de la transacción y aclara todas tus dudas",
         avatar: testimonio6
       },
    ];
    return ( 
        <section className="main container section">
            <div className="secTitle">
                <h3 className="title">
                    Testimonios
                </h3>
            </div>
            <Testimonials testimonials={testimonialData}/>
            <div className="secTitle">
                <h3 className="title">
                    Anúnciate con nosotros
                </h3>
            </div>
            <div className="banner">
                <img src={anuncio} alt="" />
            </div>
            <div className="secTitle">
                <h3 className="title">
                    Inmuebles destacados
                </h3>
            </div>
            <div className="secContent grid">
                {
                    Data.map(({id, imgSrc, terrenoTitle, location, price, description, area, label})=>{
                        return(
                            <div key={id}
                            className="singleDestination">
                                <div className="imageDiv">
                                    <img src={imgSrc} alt={terrenoTitle} />
                                </div>
                                <div className="cardInfo">
                                    <h4 className="destTitle">{terrenoTitle}</h4>
                                    <span className="continent flex">
                                        <FaMapMarkerAlt className="icon"></FaMapMarkerAlt>
                                        <span className="name">{location}</span>
                                    </span>
                                    <span className="continent flex">
                                        <FaArrowsAltH className="icon"></FaArrowsAltH>
                                        <span className="name">{area} m²</span>
                                    </span>
                                    <span className="continent flex">
                                        <MdOutlineLabel className="icon"></MdOutlineLabel>
                                        <span className="name">{label}</span>
                                    </span>
                                    <div className="fees flex">
                                        <div className="price">
                                            <h5>${price}</h5>
                                        </div>
                                    </div>

                                    <div className="desc">
                                        <p>{description}</p>
                                    </div>

                                    <button
                                      className="btn flex"
                                      onClick={() => window.open('https://www.expertosenterrenosyucatan.com/', '_blank')}
                                    >
                                      Details <FaClipboardCheck className="icon" />
                                    </button>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </section>
     );
}
 
export default Main;